import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39dbbdc0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "graph-header" }
const _hoisted_2 = {
  key: 0,
  class: "graph-header-content-error"
}
const _hoisted_3 = {
  key: 0,
  class: "graph-header-error-percentage"
}
const _hoisted_4 = { class: "graph-header-errors" }
const _hoisted_5 = {
  key: 1,
  class: "graph-header-content"
}
const _hoisted_6 = {
  key: 2,
  class: "graph-header-content"
}
const _hoisted_7 = {
  key: 3,
  class: "graph-header-content"
}
const _hoisted_8 = {
  key: 0,
  class: "graph-header-content"
}
const _hoisted_9 = {
  key: 0,
  class: "graph-header-content-calls"
}
const _hoisted_10 = {
  key: 1,
  class: "graph-header-content-calls"
}
const _hoisted_11 = { key: 2 }
const _hoisted_12 = { key: 3 }
const _hoisted_13 = {
  key: 4,
  class: "graph-header-icon"
}
const _hoisted_14 = { class: "graph-header-custom-button" }

import shortenLargeNumber from '@/utils/numberShortner';
import { HeaderType, HeaderValuesType } from '@/components/Common/graph.types';

interface Props {
  header: HeaderType;
  childQuery: HeaderValuesType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'GraphCardHeaders',
  props: {
    header: { default: () => ({}) },
    childQuery: { default: () => ({
    total: 0,
    avg: 0,
    perMin: 0,
    anomalies: 0,
  }) }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.header?.isError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (!_ctx.header.hidePercentageParam)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3))
            : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.childQuery?.total > 0 ? _unref(shortenLargeNumber)(_ctx.childQuery?.total, 1) : 0) + " " + _toDisplayString(_ctx.$t('bm.errors')), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.childQuery.perMin) + " " + _toDisplayString(_ctx.$t('apm.errors-per-min')), 1)
        ]))
      : (_ctx.header?.displayOnlyUnit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.childQuery.avg) + " " + _toDisplayString(_ctx.header?.unit), 1))
        : (_ctx.header?.showAnomaly)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.$t('anomalies')) + ": " + _toDisplayString(_ctx.childQuery.anomalies), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (!_ctx.header?.HideCenterMiscContent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    (_ctx.header?.basicInfoStyling && _ctx.header?.basicInfoStyling.enabled)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                          _createElementVNode("span", {
                            style: _normalizeStyle(_ctx.header?.basicInfoStyling.styles)
                          }, _toDisplayString(_unref(shortenLargeNumber)(_ctx.childQuery.total, 1)) + " " + _toDisplayString(_ctx.$t('apm.calls')), 5)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_ctx.childQuery.total > 0 ? _unref(shortenLargeNumber)(_ctx.childQuery.total, 1) : 0) + " " + _toDisplayString(_ctx.$t('apm.calls')), 1)),
                    (_ctx.header?.basicInfoStyling && _ctx.header?.basicInfoStyling.enabled)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                          _createElementVNode("span", {
                            style: _normalizeStyle(_ctx.header?.basicInfoStyling.styles)
                          }, _toDisplayString(_ctx.childQuery.perMin) + " " + _toDisplayString(_ctx.$t('apm.call-per-min')), 5)
                        ]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.childQuery.perMin) + " " + _toDisplayString(_ctx.$t('apm.call-per-min')), 1))
                  ]))
                : _createCommentVNode("", true)
            ])),
    (_ctx.header?.displayCustomButton)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createVNode(_component_router_link, {
            to: {
          name: _ctx.header?.customButtonProp?.routeName
            ? _ctx.header?.customButtonProp.routeName
            : 'trace',
          query: _ctx.header?.customButtonProp?.routeParams
            ? _ctx.header?.customButtonProp.routeParams
            : {
                type: _ctx.header?.customButtonProp?.key,
                entity: '',
              },
        }
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.header?.customButtonProp?.title), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})